export default "__VITE_ASSET__BAOXTOkc__"